import React, { useState, Component } from "react";
import styled from "styled-components";
import arrow from "../../../../assets/imgs/icons/load-more-arrow.svg";
// import edit from "../../../../assets/imgs/edit.svg";
import Axios from 'axios';
import {wrapperEndPoint} from "../../../Utils/Api"


let sData = {
  name:"",
  email:"",
  mobile:"",
  state:"",
  city:""
}

class LeadGenForm extends Component {

  constructor(props){
    super(props);
    this.state = {
      leadGenCities : [], //storing data from "/RBLWrapper/rbl/liabilities/getCity"
  
      selectedState: "",
      selectedCity: "",

      isNameValid:true,
      isEmailValid:true,
      isMobileValid:true,
      isStateValid:true,
      isCityValid:true

    }
}

componentDidMount(){
    // console.log(this.props.leadGenStates)
    // console.log(this.props.formInputFields)
    // console.log(sData)

}


  handleCancel = ()=>{
   
    let inputString = "Cancel" + "<split>" + "Cancel";
    window["autosubmit"](inputString);

    document.querySelectorAll(".input-block").forEach((Element) => {
      Element.classList.add("disableform");
    });
    document.querySelectorAll(".user-select").forEach((Element) => {
      Element.classList.add("fadeOut");
    });
    document.querySelectorAll(".user-input").forEach((Element) => {
      Element.classList.add("fadeOut");
    });

  }

  handleProceed = ()=>{

    //^[a-zA-z]+([\s][a-zA-Z]+)*$ 
    ///^[a-z A-Z]+$/

   if(!sData.name.match(/^[a-zA-z]+([\s][a-zA-Z]+)*$/)){ //fullName
    this.setState({isNameValid:false})
   }else{
    this.setState({isNameValid:true})
   }

   if(!sData.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){ //emailID
    this.setState({isEmailValid:false})
   }else{
    this.setState({ isEmailValid:true})
   }

   if(!sData.mobile.match(/^(\+\d{1,3}[-]?)?\d{10}$/)){ //mobileNumber
    this.setState({ isMobileValid:false})
   }else{
    this.setState({ isMobileValid:true})
   }

   if(sData.state == ""){//state
    this.setState({ isStateValid:false})
   }else{
    this.setState({ isStateValid:true})
   }

   if(sData.city == "" ){//city
    this.setState({ isCityValid:false})
   }else{
    this.setState({ isCityValid:true})
   }

  // console.log(sData.city)

    setTimeout(() => {

      if(this.state.isNameValid && 
        this.state.isEmailValid && 
        this.state.isMobileValid && 
        this.state.isStateValid && 
        this.state.isCityValid){
     
        let inputString = "Proceed" + "<split>" + JSON.stringify(sData);
        window["autosubmit"](inputString);
    
       console.log("to backend - ",JSON.stringify(sData))

        document.querySelectorAll(".input-block").forEach((Element) => {
          Element.classList.add("disableform");
        });
        document.querySelectorAll(".user-select").forEach((Element) => {
          Element.classList.add("fadeOut");
        });
        document.querySelectorAll(".user-input").forEach((Element) => {
          Element.classList.add("fadeOut");
        });
    
       }  
    }, 100);
  }

  handleStateSelect = (ev) => {

    // this.setState({
    //   selectedState:ev.target.value,
    //  // selectedCity: "",
    //   // leadGenCities:[]
    // })

    sData.state = ev.target.value;
    sData.city=""
 
    document.getElementById("sf_leadGen_CityDropdown").selectedIndex = 0;

    Axios.post(wrapperEndPoint.genericRouterURL, {
      wrapperEndPoint: "/RBLWrapper/rbl/liabilities/getCityLRSForm",
      findIFSC: ev.target.value,
    },{headers: {
      "Content-Type": "application/json"}
  })
      .then((response) => response.data)
      .then((response) => {
        this.setState({
          leadGenCities:response.response.responseJson.leadGenCities
        })
      })
      .catch((error) => {
        console.log(error);
      });

    //  console.log(sData)
  }

  handleCitySelect = (ev) => {

    sData.city = ev.target.value
    this.setState({
      selectedCity: ev.target.value,
      isCityValid:true,
    })

  }

  render() {

    return (
      <LeadGenFormWrapper>
        {/* name */}

        <div>{this.props.formInputFields.includes("FullName")?
          <div>
            <label className = "title-label" >Full Name</label>
            <input
                className="user-input"
                placeholder="Enter your Full Name"
                onChange={(ev)=>{sData.name=ev.target.value,this.setState({isNameValid:true})}} 
          />
          {!this.state.isNameValid?
            <div className="sf-error">
              Please enter a valid Name
            </div>:null}
          </div>
      :null}

        </div>

        {/* email */}

        <div>{this.props.formInputFields.includes("Email")?
          <div>
            <label className = "title-label" >Email</label>
            <input
                className="user-input"
                placeholder="Enter your Email ID"
                onChange={(ev)=>{sData.email=ev.target.value,this.setState({isEmailValid:true})}}
          />
          {!this.state.isEmailValid?
            <div className="sf-error">
              Please enter a valid Email
            </div>:null}
          </div>
      :null}

        </div>

          {/* mobile */}

          <div>{this.props.formInputFields.includes("Mobile")?
          <div>
            <label className = "title-label" >Mobile Number</label>
            <input
                className="user-input"
                placeholder="Enter your Mobile Number"
               // maxLength="10" 
                onChange={(ev)=>{sData.mobile=ev.target.value,this.setState({isMobileValid:true})}}
          />
          {!this.state.isMobileValid?
            <div className="sf-error">
              Please enter a valid Mobile Number
            </div>:null}
          </div>
      :null}
        </div>

        {/* state */}
        <div>{this.props.formInputFields.includes("State")?
          <div>
            <label className = "title-label" >State</label>
            <select
             className="user-select"
             onChange={(ev)=>{this.handleStateSelect(ev),this.setState({isStateValid:true})}}
            >
             <option value="" hidden>Please select the State</option>
             {this.props.leadGenStates.map((item, i) => {
               return (
                 <option value={item.name} key={i}>
                   {item.name}
                 </option>
               );
             })}
           </select>
           {!this.state.isStateValid?
            <div className="sf-error">
              Please select a valid State
            </div>:null}
          </div>:null
          }
          </div>

        {/* city */}
        <div>{this.props.formInputFields.includes("City")?
        <div>
          <label className = "title-label" >City</label>
          
          <select id = "sf_leadGen_CityDropdown"
             className="user-select"
             onChange={(ev)=>{this.handleCitySelect(ev),this.setState({isCityValid:true})}}
             disabled={this.state.leadGenCities.length == 0?true:false}
             value={this.state.selectedCity}
            >
             <option value="" hidden>Please select the City</option>
             {this.state.leadGenCities.map((item, i) => {
               return (
                 <option value={item.name} key={i}>
                   {item.name}
                 </option>
               );
             })}
           </select>
           {!this.state.isCityValid?
            <div className="sf-error">
              Please select a valid City
            </div>:null}
        </div>:null
        }</div>

        {/* **************** Proceed/Cancel *************** */}
        <div className="action-elem" onClick={(e) => this.handleProceed("click")}>
          Proceed
        </div>
        <div className="action-elem" onClick={(e) => this.handleCancel("click")}>
          Cancel
        </div>
      
      </LeadGenFormWrapper>
    );
  }
}

const LeadGenFormWrapper = styled.div`

  //background: pink;
  width: 100%;
  min-width: 280px;
  height: auto;
  margin: 10px 0;

  .sf-error {
    color: red;
    height: auto;
    width: 100%;
    background-color: antiquewhite;
    padding: 2px;
    font-size: 11px;
    margin-top: -8px;
  
  }

  & .input-block{
      margin-bottom:10px;
  }
  & .title-label{
      padding-left: 4px;
    
      font-size: 13px;

  }
  & .user-select{
      background-color: #fff;
      border: 1px solid #ccc;
      height: 32px;
      width: 100%;
      color: #CCC;
      padding-left: 10px;
      font-size:13px;
      color: #666666;
      margin-top: 2px;
      margin-bottom:8px;
  }

  & .user-input{
      background-color: #fff;
      border: 1px solid #ccc;
      height: 32px;
      width: 100%;
      color: #CCC;
      padding-left: 15px;
      font-size:13px;
      color: #666666;
      margin-top: 4px;
      margin-bottom:8px;
  }

  select {
    background: url(${arrow}) no-repeat right;
    -webkit-appearance: none;
     background-position-x: 95%;
     cursor:pointer;
  }

  .disableform{
    pointer-events:none
  }
  .fadeOut{
    background: #f8f8f8;
  }

`;

export default LeadGenForm;